import { BarChart3, ExternalLink } from "lucide-react";
import { FARMANALIZA_URL, trackFarmanaliza } from "@/lib/farmanaliza";

const fmtEur = (v) => `${(Number(v) || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const FarmanalizaStalledBanner = ({ count, value }) => (
  <div className="rounded-lg border border-sky-200 bg-sky-50 p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="stalled-farmanaliza-banner">
    <BarChart3 className="h-6 w-6 text-sky-700 shrink-0" strokeWidth={1.75} />
    <div className="flex-1 text-sm text-sky-950">
      <b>Tienes {count} {count === 1 ? "referencia parada" : "referencias paradas"} por {fmtEur(value)} a PVL.</b>{" "}
      Con Farmanaliza controlas el stock, la evolución de ventas y el cuadro de mando de tu farmacia para que no se vuelva a acumular.
    </div>
    <a href={FARMANALIZA_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackFarmanaliza("stalled")}
      data-testid="stalled-farmanaliza-link"
      className="inline-flex items-center gap-1.5 bg-sky-700 text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-sky-800 whitespace-nowrap">
      Conocer Farmanaliza <ExternalLink className="h-3.5 w-3.5" />
    </a>
  </div>
);
